import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { Optional_Subject_ListAPI } from "../../../helper/Redux/Slices/DDLSlice/DDLSlice";
import { OpenPopUp } from "./OpenPopUp";

export const OptionalSubject = (props) => {
    const { setSelectedSubID, SelectedSubID, LicentiateCertificateSubMenuID, LicentiateCertificateID, SelectedSubName, setSelectedSubName } = props
    const dispatch = useDispatch();


    useEffect(() => {
        if (SelectedSubID == 0)
            getListData()
    }, [SelectedSubID])

    const getListData = () => {
        const data = {
            M_UserID: 0,
            Flag: "OptionalSub_List"
        }
        dispatch(Optional_Subject_ListAPI({ data }))
    }

    //select id onclick
    const handleselectSubID = (i) => {
        if (i) {
            setSelectedSubID(i?.m_IndicatorID)
            setSelectedSubName(i?.indicator_Name)
        } else {
            setSelectedSubID(0)
        }
    }

    const { DDLData, isLoading } = useSelector(state => state.Optional_Subject_ListData)

    return (
        <>
            {SelectedSubID == 0
                ?
                <div className="row  p-2 m-0 bg-white mt-3 col-lg-11 mx-auto px-5 pb-4 pt-3 rounded shadow optional_subject" >
                    <div className="col-12 row px-0" >
                        {DDLData && DDLData?.table && DDLData.table.length > 0 && DDLData.table.map((i, j) => (
                            <div className="col-lg-6 col-xl-4 col-12 py-2 mt-0" key={i?.m_IndicatorID}>
                                <i className="fa-solid fa-sailboat pe-2 width_color" ></i>
                                <button className="border-0 p-0 bg-transparent" onClick={() => handleselectSubID(i)}>
                                    {i?.indicator_Name}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                : <OpenPopUp
                    LicentiateCertificateID={LicentiateCertificateID}
                    LicentiateCertificateSubMenuID={LicentiateCertificateSubMenuID}
                    SelectedSubID={SelectedSubID}
                    setSelectedSubID={setSelectedSubID}
                    SelectedSubName={SelectedSubName}
                />}
        </>
    )
}